var options: any = { month: "long" };

export default function formatDate(date: any) {
  if (date) {
    var Xmas95 = new Date(date);
    const day = Xmas95.getDate();
    const month = new Intl.DateTimeFormat("en-US", options).format(Xmas95);
    const year = Xmas95.getFullYear();
    const time = `${Xmas95.getHours()}:${Xmas95.getMinutes()}`;

    return `${day} ${month}, ${year} at ${time}`;
  } else {
    return "Invalid date";
  }
}

export function addTime(minutesToAdd: number) {
  const currentDate = new Date();
  // A minute is 60000 milliseconds
  const newDate = new Date(Date.now() + minutesToAdd * 60000);
  return {
    current: currentDate,
    added: newDate,
  };
}
